import { combineReducers } from 'redux';

import company from 'app/shared/reducers/userManagement/company';
import currentUser from 'app/shared/reducers/userManagement/currentUser';
import companyUsers from 'app/shared/reducers/userManagement/companyUsers';
import activityHistory from 'app/shared/reducers/userManagement/activityHistory';

const rootUserManagementReducer = combineReducers({
    company,
    currentUser,
    companyUsers,
    activityHistory,
});

export default rootUserManagementReducer;
